module.exports = __webpack_public_path__ + "img/02-title-01.16d231ef.png";